import { FC } from 'react';

import invoiceImg from 'assets/brand/invoice@2x.png';
import { InvoiceFromList } from 'common/hooks/useGetInvoicesQuery';
import Button from 'components/_core/Button';
import SunshineModal from 'components/_core/SunshineModal';
import Text from 'components/_core/Text';
import useToast from 'components/ToastProvider/useToast';
import logger from 'helpers/logger';

import { useMarkInvoiceAsPaid } from '../../../mutations/useMarkInvoiceAsPaid';
import { useInvoiceModals } from '../..';
import locales from './locales';

export type MarkAsPaidModalProps = Pick<
  InvoiceFromList,
  'clientId' | 'companyProfileId' | 'fiscalId' | 'invoiceId' | 'status'
>;

const MarkAsPaidModal: FC<MarkAsPaidModalProps> = ({
  clientId,
  companyProfileId,
  fiscalId,
  invoiceId,
  status,
}) => {
  const { hideModal } = useInvoiceModals();
  const { showToast } = useToast();

  const [markInvoiceAsPaid, { loading }] = useMarkInvoiceAsPaid({
    clientId,
    companyProfileId,
    invoiceId,
    status,
  });

  const onConfirm = async () => {
    try {
      await markInvoiceAsPaid();

      hideModal();

      showToast({
        message: locales.formatString(
          locales.successMessage,
          fiscalId,
        ) as string,
        type: 'success',
      });
    } catch (error) {
      logger.error(error);
      showToast({ message: locales.errorMessage, type: 'error' });
    }
  };

  return (
    <SunshineModal isOpen onClose={hideModal}>
      <SunshineModal.Header />

      <SunshineModal.Body>
        <SunshineModal.Body.Image src={invoiceImg} />
        <SunshineModal.Title>{locales.title}</SunshineModal.Title>
        <Text>{locales.description}</Text>
      </SunshineModal.Body>

      <SunshineModal.Footer>
        <Button
          isDisabled={loading}
          onClick={hideModal}
          variant="inline-secondary"
        >
          {locales.cancel}
        </Button>

        <Button isLoading={loading} onClick={onConfirm}>
          {locales.confirm}
        </Button>
      </SunshineModal.Footer>
    </SunshineModal>
  );
};

export default MarkAsPaidModal;
